import PropTypes from 'prop-types'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import ReactPlayer from 'react-player'
import useAllSitePage from '../../hooks/useAllSitePage'
import Button from '../../shared/Button/Button'
import "./BannerVideo.scss"

const BannerVideo = ({ bannerVideo }) => {
  const pagesPath = useAllSitePage()
  const { allSitePage: matchPages } = pagesPath

  return (
    <div className="banner-video-container my-5">
        <div className="mx-auto row">
          <div className="col-12 col-md-6">
            <div className="ratio ratio-16x9 responsive-banner-video">
              <ReactPlayer
                className="embed-responsive-item"
                url={`https://www.youtube.com/embed/${bannerVideo.videoId}?rel=0`}
                controls={true}
                width="100%"
                height="100%"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column align-items-center ">
            <div className="w-100  h-100 d-flex flex-column  responsive-banner-video-content">
              <ReactMarkdown
                renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
                children={bannerVideo.summary}
                className="markdown-videoBanner"
              />
              <div>
                {bannerVideo?.url && (
                  <Button
                    classButton={`videoBanner-button-style text-left button-form rounded-0`}
                    button={bannerVideo}
                    customButton={{ variant: 'dark_outline', size: "normal", shape: 'pill' }}
                    classContainer=" d-flex"
                    matchPages={matchPages?.nodes}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default BannerVideo

BannerVideo.propTypes = {
  bannerVideo: PropTypes.object.isRequired
}
